import { BaseApi } from "@newview/infrastructure";
export abstract class BasicDataBaseApi extends BaseApi {
    public get ProxyName(): any {
        return 'BasicDataApi';
    }
  
}